import './MainNav.scss';

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import A from 'components/A';
import Button from 'components/Button';
import Icon from 'components/Icon';
import Nav from 'components/Nav';
import NavItem from 'components/NavItem';
import UserMenu from 'components/UserMenu';

export default class MainNav extends React.Component {
    static propTypes = {
        hasUnreadMessages: PropTypes.bool.isRequired,
        pathname: PropTypes.string.isRequired,
        user: PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);

        this.links = [{
            text: 'Admin',
            submenu: [
                {
                    text: 'Users List',
                    href: '/users'
                }, {
                    text: 'New User',
                    href: '/user/new'
                }, {
                    text: 'New Member',
                    href: '/business/new'
                }
            ],
            renderTest: (user) => user.isAdmin === true
        },
        /*{
            text: 'Search',
            href: '/opportunities',
            renderTest: (user) => user.company == null
        },*/ {
            text: 'Search',
            href: '/freelancers',
            renderTest: (user) => user.company != null
        }, /*{
            text: 'Job Postings',
            href: '/postings/published',
            activeTest: (pathname) => {
                return ['/postings/published', '/postings/drafts', '/postings/fulfilled'].indexOf(pathname) !== -1;
            },
            renderTest: (user) => user.company != null
        },*/ {
            text: 'Messages',
            href: '/messages'
        }, {
            text: 'Account',
            submenu: [
                {
                    text: 'Profile',
                    href: '/account/profile'
                }, {
                    text: 'Business',
                    href: '/account/business',
                    renderTest: (user) => user.company != null
                }, {
                    text: 'Billing',
                    href: '/account/billing',
                    renderTest: (user) => user.company != null
                }, {
                    text: 'Notifications',
                    href: '/account/notifications'
                }, {
                    text: 'Security',
                    href: '/account/security'
                }
            ],
            activeTest: (pathname) => {
                return ['/account/profile', '/account/business', '/account/billing', '/account/notifications', '/account/security'].indexOf(pathname) !== -1;
            }
        }/*, {
            text: 'Messages',
            href: '/messages'
        }*/];

        this.links.forEach((link) => {
            if(link.submenu != null) {
                this[`${link.text}WrapperRef`] = React.createRef();
                this[`${link.text}Ref`] = React.createRef();
            }
        });
    }

    _showSubmenu(item) {
        if(this[`${item.text}WrapperRef`].current.parentNode.classList.contains('a-main-nav__menu-item--submenu-open') === false) {
            this[`${item.text}WrapperRef`].current.style.height = this[`${item.text}Ref`].current.offsetHeight + 'px';
            this[`${item.text}WrapperRef`].current.parentNode.classList.add('a-main-nav__menu-item--submenu-open');
        } else {
            this[`${item.text}WrapperRef`].current.style.height = '0';
            this[`${item.text}WrapperRef`].current.parentNode.classList.remove('a-main-nav__menu-item--submenu-open');
        }
    }

    generateMenuItem(item, index) {
        if(item.submenu != null) {
            if(item.renderTest == null || item.renderTest(this.props.user) === true) {
                return (
                    <NavItem className="a-nav-item--has-submenu" key={index}>
                        <Button
                            className={classNames({'a-nav-item__button--active': item.activeTest != null ? item.activeTest(this.props.pathname) : this.props.pathname === item.href})}
                            noStyles
                            onClick={this._showSubmenu.bind(this, item)}>
                            {item.text}
                            <Icon type="chevron-down"/>
                        </Button>
                        <div className="c-nav__submenu--wrapper"
                             ref={this[`${item.text}WrapperRef`]}>
                            <ul className="c-nav__submenu"
                                ref={this[`${item.text}Ref`]}>
                                {item.submenu.map((subitem, index) => this.generateMenuItem(subitem, index))}
                            </ul>
                        </div>
                    </NavItem>
                );
            }
        } else {
            if(item.renderTest == null || item.renderTest(this.props.user) === true) {
                return (
                    <NavItem key={index}>
                        <A className={classNames('c-nav-item__link', {
                            'a-nav-item__link--active': item.activeTest != null ? item.activeTest(this.props.pathname) : this.props.pathname === item.href,
                            'a-nav-item__link--has-unread-messages': item.href === '/messaging' && this.props.hasUnreadMessages === true
                        })}
                           to={item.href}>
                            {item.text}
                            {item.href === '/messages' && this.props.hasUnreadMessages === true ? (
                                <div className="a-nav-item__link__unread-messages-dot" />
                            ) : null}
                        </A>
                    </NavItem>
                );
            }
        }
    }

    render() {
        return (
            <Nav className="c-main-nav">
                <ul className="c-nav__menu c-main-nav__menu">
                    {this.links.map((link, index) => this.generateMenuItem(link, index))}
                </ul>

                <UserMenu pathname={this.props.pathname} user={this.props.user} />
            </Nav>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/MainNav/index.js